import PropTypes from "prop-types";
import styles from "./DebicheckLink.module.scss";
import formStyles from "../../atoms/staticForms/StaticForms.module.scss";
import { CustomContainer, Link } from "../../atoms/DependencyHelper";
import config from "../../../config/index";
import * as Analytics from "../../../services/analyticsUtag";


const DebicheckLink = ({ msgType }) => {

  const Debi_cust_msgs = {
    consent: {
      head: "DebiCheck has been enabled for this application",
      info: "To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It's an extra layer of security for your peace of mind."
    },
    noConsent: {
      head: "DebiCheck was not enabled for this application",
      info: "We may, however, still submit your application for a DebiCheck. To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It's an extra layer of security for your peace of mind."
    },
    educational: {
      head: "DebiCheck",
      info: "To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It's an extra layer of security for your peace of mind."
    }
  }

  const MsgToShow = Debi_cust_msgs[msgType];

  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  
  const handleMandateLinkClick = () => {
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: debicheck`
    });
  };


  return (

    <CustomContainer className={`${formStyles["main-container"]} ${styles["debi_link_container"]}`}>

      <CustomContainer className={`${styles["debi_link_container_top"]}`}>
        <img className={`${styles["debi_link_icon"]}`} src={`${imagePrefix}/assets/images/debi-check-logo.svg`}/>
        <CustomContainer className={`${styles["debi_mandate_link_head"]}`}>
          {MsgToShow.head}
        </CustomContainer>
      </CustomContainer>

      <CustomContainer className={`${styles["debi_link_info"]}`}>

        <CustomContainer className={`${styles["debi_mandate_link_descr"]}`}>
          {MsgToShow.info}
        </CustomContainer>

        <CustomContainer className={`${styles["debi_mandate_action_link"]}`}>

          <Link legacyBehavior href={"/cloud/profile/debicheck"} passHref={true}>
            <a target="_blank" onClick={handleMandateLinkClick} className={`${styles["action_link"]}`}>
              View my DebiCheck mandate
              <span className={`${styles["debi_link_anc_icon"]}`} >
                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.7 6L3.50001 12L3.50001 0L10.7 6Z" fill="#282828" />
                  <mask id="debi_link_anc_icon" mask-type="alpha" maskUnits="userSpaceOnUse" x="3" y="0" width="8" height="12">
                    <path fillRule="evenodd" clipRule="evenodd" d="M10.7 6L3.50001 12L3.50001 0L10.7 6Z" fill="white" />
                  </mask>
                  <g mask="url(#debi_link_anc_icon)">
                    <rect x="0.5" width="12" height="12" fill="#282828" />
                  </g>
                </svg>
              </span>
            </a>
          </Link>
        </CustomContainer>
      </CustomContainer>
    </CustomContainer>
  )
}

DebicheckLink.propTypes = {
  msgType: PropTypes.string,
}

DebicheckLink.defaultProps = {
  msgType: "noConsent",
};

export default DebicheckLink;